<template>
  <section id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" id="pageTitle">Contact</h2>

          <p>
            <a href="mailto:info@blackmondayradio.nl">info [at] blackmondayradio.nl</a>
            <br />
            <br />
            
            <strong>Post Adres</strong>
            <br />Black Monday Delta FM
            <br />p/a De Marke 3
            <br />7692 AT MARIENBERG (ov.)
            <br />The Netherlands
            <br />
            <br />
            <strong>Studio Adres</strong>
            <br />Karel Doormanlaan 3
            <br />7681 AV Vroomshoop
            <br />
          </p>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "contact",

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "blackmondayradio.nl - Metal op de radio ! - Contact",
  }
}
</script>

<style scoped>
p {
    color: #ffffff;
    letter-spacing: 1px;
}
</style>